// 易点PLUS-活动应用
const routes = [
  {
    // 微站-支付结果中转页（适用于合作方无法使用#路由的情况）
    path: '/scenPayResMiddlePage',
    name: 'scenPayResMiddlePage',
    component: () => import('@/views/scenario/payResMiddlePage.vue'),
    meta: {
      requiresAuth: false,
      title: '微站支付中间页'
    },
  },
  // ----------------------------- 支付兑换码 ---------------------------------
  {
    // 支付兑换码-首页
    path: '/scenPayExchange',
    name: 'scenPayExchange',
    component: () => import('@/views/scenario/payExchange/index.vue'),
    meta: {
      requiresAuth: true,
      title: '支付兑换码'
    },
  },
  {
    // 支付兑换码-手机号绑定
    path: '/scenarioPhoneLogin',
    name: 'scenarioPhoneLogin',
    component: () => import('@/views/scenario/payExchange/phoneLogin.vue'),
    meta: {
      requiresAuth: false,
      title: '手机号绑定'
    }
  },
  {
    // 支付兑换码-兑换记录
    path: '/scenarioMyOrder',
    name: 'scenarioMyOrder',
    component: () => import('@/views/scenario/payExchange/myOrder.vue'),
    meta: {
      requiresAuth: false,
      title: '兑换记录'
    }
  },
  {
    // 支付兑换码-pdf
    path: '/scenarioPdf',
    name: 'scenarioPdf',
    component: () => import('@/views/scenario/payExchange/pdf.vue'),
    meta: {
      requiresAuth: false,
      title: '支付兑换码'
    }
  },
  // ------------------------------- 签到 -----------------------------------
  {
    // 签到-首页
    path: '/signInGift',
    name: 'signInGift',
    component: () => import('@/views/scenario/signInGift/index.vue'),
    meta: {
      requiresAuth: true,
      title: '签到'
    }
  },
  {
    // 签到-记录
    path: '/signInRecord',
    name: 'signInRecord',
    component: () => import('@/views/scenario/signInGift/record.vue'),
    meta: {
      requiresAuth: false,
      title: '我的奖品'
    }
  },
  {
    // 签到-详情
    path: '/signInDetail',
    name: 'signInDetail',
    component: () => import('@/views/scenario/signInGift/detail.vue'),
    meta: {
      requiresAuth: false,
      title: '详情'
    }
  },


]

export default routes
